"use client";
import { Grid } from "@mantine/core";
import PersonCard from "./PersonCard";

export default function TeamModule() {
  const teamData = [
    {
      name: "Dr Oliver Kidd",
      position: "Co-founder",
      description:
        "Oliver holds both a scholarship in Medicine (MBBS) and a 1st class degree in Gastroenterology and Hepatology from Imperial College London. He has taught IB science for 9 years, across 4 countries, totalling over 4,100 hours. He oversees the website at Tiber. Outside this, he competes internationally in sailing.",
      imageName: "OKidd",
    },
    {
      name: "Nicolas Benoit",
      position: "Co-founder",
      description:
        "Nicolas holds a 1st class degree, a PhD in Biomedical Engineering, and a Medical degree (MBBS), all from Imperial College London. He has taught IB science for 9 years, across 6 countries, totalling over 4,500 hours. He oversees content at Tiber. Outside this, he is an avid footballer.",
      imageName: "NBenoit",
    },
    {
      name: "Kate Bellia-Simpson",
      position: "Biology",
      description:
        "Kate is a qualified teacher with a background in Biomedical Science and Graduate Medicine, undertaken at St Georges University. She has taught IB science internationally for over 20 years and lectures in applied Human Biology at London colleges. At present, she is studying for a Masters in Law. She loves to spend time with her family, travel and pursue the international jazz circuit.",
      imageName: "KBelliaSimpson",
    },
    {
      name: "James Clarke",
      position: "Physics",
      description:
        "James graduated from Oxford University with a Masters in Physics. Since then, he has taught IB Physics at several leading UK schools over 7 years, including Wellington College. He is currently teaching IB Physics at St Catherine's School. Before his transition to academia, he worked in asset management for a number of years. In his free time, he is a keen cricketer, golfer, and skiier.",
      imageName: "JClarke",
    },
    {
      name: "Manuela Dicu",
      position: "Biology & Chemistry",
      description:
        "Manuela attained an IB diploma with honors, and holds a certificate in Functional Neuroanatomy from Cambridge University. She has particular interest in nervous system regulation and stress management in students. She is currently completing her Medical degree at Brighton and Sussex Medical School. Outside work, she works as a social media manager for organisations and enjoys reading.",
      imageName: "MDicu",
    },
    {
      name: "Natalia Nash",
      position: "Biology & Chemistry",
      description:
        "Natalia is a former IB student, currently completing her Medical degree (MBBS) at University College London (UCL). She has particular interest in surgery, where she actively conducts research, and organises national conferences for students around the UK interested in the surgical field. Outside her academia, she loves dancing ballet and travelling with her family.",
      imageName: "NNash",
    },
    {
      name: "Leo Lai",
      position: "Biology",
      description:
        "Leo is a former IB student, currently completing a Bachelors of Science in Endocrinology, alongside finishing his Medical degree (MBBS) at Imperial College London. He is in his 5th consecutive year of teaching IB STEM subjects to students around the world. At Tiber Tutor, he contributes towards several areas, primarily questions. When relaxing, he loves to read his favourite book - Wuthering Heights.",
      imageName: "LLai",
    },
    {
      name: "Louise Steenbergen",
      position: "Biology",
      description:
        "Louise undertook the IB and is completing a Bachelor of Science in Actuarial Science at Queen Mary University. She also holds particular interest in Mathematics and its applied use to evaluate financial risk. In her free time she enjoys spending time with her family & friends and watching new movies.",
      imageName: "LSteenbergen",
    },
    {
      name: "Md. Sayem Hussaim",
      position: "AV Editor",
      description:
        "Sayem has worked with many individuals worldwide, across a wide breadth of audio-visual editing platforms. His team give the Tiber Tutor videos their characteristic shine! He previously worked as a data-entry analyst and loves to spend time with his family.",
      imageName: "SHussaim",
    },
  ];
  return (
    <Grid grow mt={20} mb={"12rem"} gutter={"xl"}>
      {teamData.map((person, indx) => (
        <Grid.Col
          key={person.name}
          span={{ base: 12, md: 6, lg: indx < 2 ? 6 : 4 }}
        >
          <PersonCard {...person} indx={indx} />
        </Grid.Col>
      ))}
    </Grid>
  );
}
